<div>
  <div class="content-search">
    <a class="go-home" routerLink="/" routerLinkActive="active" (click)="clearSessionSearchText()">
      <mat-icon class="material-icons-outlined icon-back">arrow_back_ios_new</mat-icon>Volver a Bandejas
    </a>
    <form class="search-form-well">
      <mat-form-field  class="search-well dense-3">
        <mat-label class = "label-well-or-field">Buscá un pozo o yacimiento</mat-label>
        <input type="text"  value={{textSearch}} aria-label="Well" matInput #searchText (keyup.enter)="sendMessageToWellList(searchText.value,false)">
        <span matSuffix class="cursor-pointer" (click)="sendMessageToWellList(searchText.value,false)">
          <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
        </span>
        <!-- TODO: Comentado hasta que se decida si se va usar el autocomplete 
        <input type="text"
               placeholder="Seleccione un pozo"
               aria-label="Well"
               matInput
               [formControl]="wellControl"
               [matAutocomplete]="auto"
               #searchText
               (keyup.enter)="sendMessageToWellList(searchText.value)">
        <span matSuffix class="cursor-pointer" (click)="sendMessageToWellList(searchText.value)">
          <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
        </span>
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let well of filteredWells| async" [value]="well">
            <div class="options-wells">
              <span class="option-well-name" [innerHTML]="well.wellCommonName| highlight: toHighlight"></span>
              <span class="option-well-project" [innerHTML]="well.project | highlight: toHighlight"></span>
            </div>
          </mat-option>
        </mat-autocomplete> -->
      </mat-form-field>    
    </form>
  </div>
  
</div>
